import { Card, Title, Box, Text, Link, Checkbox } from '@nimbus-ds/components';
import { useTranslationAccount } from 'domains/Account/hooks';

function Skeleton() {
  const t = useTranslationAccount('businessDataPage.taxesWithExceptions');
  return (
    <Card>
      <Card.Header>
        <Title as="h4">{t('title')}</Title>
      </Card.Header>
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="3">
          <Checkbox.Skeleton width="400px" />
          <Box display="flex" flexDirection="column" gap="2">
            <Title.Skeleton as="h4" width="87px" height="18px" />
            <Text.Skeleton width="480px" />
          </Box>
          <Link.Skeleton width="150px" />
        </Box>
      </Card.Body>
    </Card>
  );
}

export default Skeleton;
